import React, { useCallback, useState, useEffect } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useHistory, useParams } from 'react-router-dom';
import { ErrorMessage } from '@hookform/error-message';
import {
  Row,
  Form,
  Col,
  Input,
  Container,
  Card,
  CardBody,
  Button
} from 'reactstrap';
import { toast } from 'react-toastify';
import Select from 'react-select/async';
import { LocationOn } from '@material-ui/icons';
import ContactService from '../../../Contact/services/contactService';
import ListComments from '../ContactDetails/Comments/CommentsList';
import CommentModal from '../ContactDetails/Comments/CommentsForm';
import ModalComment from '../ContactDetails/Comments/ModalUpdateComment';
import { FiPlus } from 'react-icons/fi';
import ReactButton from 'components/Buttons/ReactButton';
import contactService from '../../services/contactService';
import CustomFieldsInputsForm from '../../../shared/components/CustomFieldsInputsForm';
import Loader from 'components/Loader';
import { custom_select } from '../../../../../assets/styles/multiple_select';
import { useSearchAccounts } from '../../../Account/hooks/useSearchAccounts';
import SimpleHeader from 'components/Headers/SimpleHeader.js';
import { entitiesName } from 'views/CRM/shared/utils/entitiesName';
import { useEntityCustomFieldsByRecordType } from 'views/fieldConfigs/hooks/useCustomFieldsByRecordType';
import { toBrazilianFullDate } from 'views/CRM/shared/utils/date';
import { formatCustomFieldsToDisplay } from 'views/CRM/shared/helpers/customFieldsHelpers';
import { formatCustomFieldsToSubmit } from 'views/CRM/shared/helpers/customFieldsHelpers';
import AccountOpportunities from '../../../Account/form/AccountDetails/AccountOpportunities';
import ContactProtocolsAndOpportunities from './ContactProtocolsAndOpportunities';
import OpportunityService from '../../../Opportunity/services/opportunityService';
import { removeMaskSpecialCharacters } from 'views/CRM/shared/utils/phoneNumberHelpers';
import TemplatesModal from 'views/ServicePanel/components/QueueContent/components/Contact/TemplatesModal';
import { SearchTagClientInput } from 'components/Inputs/SearchTagClientInput';
import { FlexController } from 'components/FlexControllerInput';
import { getDefaultCountry } from 'services/ServiceCOUNTRYS';
import { normalizePhoneNumber } from 'utils/fuctions/internationalPhoneFormatter';
import { normalizeDDI } from 'utils/fuctions/internationalPhoneFormatter';
import ContactAddress from './ContactAddress';
import AddAddressModal from 'components/AddAddressModal';

const sectionStyle = {
  backgroundColor: 'rgb(238 239 242)',
  border: '1px solid rgb(233 233 233)',
  padding: '0.8rem 1rem',
  borderRadius: '0.1rem'
};

const ContactDetails = (
  showCallIconOnPhoneField = false,
  showMessageIconOnPhoneField = false
) => {
  const history = useHistory();
  const { control, handleSubmit, errors, setValue, reset, watch } = useForm();
  const { contactId, recordTypeId } = useParams();
  const [contactEdit, setContactEdit] = useState(null);

  const { isSearching, filterAccounts } = useSearchAccounts();
  const [accounts, setAccounts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tags, setTags] = useState([]);
  const [
    isModalTemplateMessageContactOpen,
    setIsModalTemplateMessageContactOpen
  ] = useState(false);
  const [whatsAppMessageContactInfo, setWhatsAppMessageContactInfo] = useState(
    {}
  );
  const [refetchContactValue, setRefetchContact] = useState(false);
  const [contactAddresses, setContactAddresses] = useState([]);

  const refetchContact = useCallback(
    () => setRefetchContact((prev) => !prev),
    []
  );

  const reloadContact = useCallback(() => {
    if (contactId) {
      contactService
        .getContactAddresses(contactId)
        .then((addressResponse) => {
          const addresses = addressResponse?.data?.data || [];
          setContactAddresses(addresses);
        })
        .catch((error) => {
          console.error('Erro ao recarregar endereços:', error);
        });
    }
  }, [contactId]);

  const { getCustomFields, customFields, isLoadingCustomFields } =
    useEntityCustomFieldsByRecordType(entitiesName.CONTACT, recordTypeId);

  useEffect(() => {
    getCustomFields();
  }, [getCustomFields]);

  function handleWhatsAppMessage(phone) {
    let ddi = '';
    let number = '';

    if (typeof phone === 'object' && phone !== null) {
      ddi = phone.ddi || '';
      number = phone.number || '';
    } else if (typeof phone === 'string') {
      number = phone;
    }

    const phoneNumberWithoutMask = removeMaskSpecialCharacters(number);
    let data = {
      nome: contactEdit?.name,
      telefone: phoneNumberWithoutMask !== '' ? phoneNumberWithoutMask : '',
      ddi: ddi
    };

    setWhatsAppMessageContactInfo(data);
    setIsModalTemplateMessageContactOpen(!isModalTemplateMessageContactOpen);
    return whatsAppMessageContactInfo;
  }

  const [listComments, setListComments] = useState([]);

  const [openModalCreateComment, setOpenModalCreateComment] = useState(false);

  const [dataCommentUpdate, setDataCommentUpdate] = useState([]);
  const [openModalUpdateComment, setOpenModalUpdateComment] = useState(false);
  const [fullOpportunities, setFullOpportunities] = useState([]);

  const sections = [
    { title: 'Protocolo', name: 'protocols', data: contactEdit?.protocols },
    {
      title: 'Oportunidade',
      name: 'opportunity',
      data: fullOpportunities
    }
  ];

  useEffect(() => {
    setLoading(true);
    if (contactId) {
      contactService
        .getContactById(contactId)
        .then(({ data }) => {
          const accounts = data?.data?.accounts || [];
          const accountOptions = accounts.map((account) => ({
            label: account.accountName,
            value: account.accountId
          }));
          setAccounts(accountOptions);

          const tags = data?.data?.tags?.map((tag) => ({
            label: tag.name,
            value: tag.id
          }));

          setTags(tags);

          const contact = {
            ...data?.data,
            phone: data?.data?.phone
          };

          const formattedContact = formatCustomFieldsToDisplay(
            contact,
            customFields
          );

          const ddi = data?.data?.ddi?.startsWith?.('+')
            ? data?.data?.ddi?.replace?.('+', '')
            : data?.data?.ddi;

          const resetValues = {
            ...formattedContact,
            phone: {
              ddi,
              number: data?.data?.phone
            }
          };

          reset(resetValues);

          if (data?.data?.opportunity && data.data.opportunity.length > 0) {
            const opportunityPromises = data.data.opportunity.map((opp) =>
              OpportunityService.getById(opp.recordTypeId, opp.id)
                .then((response) => {
                  const oppData = response.data.data;
                  return {
                    ...oppData,
                    fase: oppData.stageName || oppData.fase || '',
                    created_at: oppData.createdAt || oppData.created_at || '',
                    createdByName:
                      oppData.createdByName || oppData.responsibleName || ''
                  };
                })
                .catch(() => null)
            );

            Promise.all(opportunityPromises).then((opportunities) => {
              const validOpportunities = opportunities.filter(
                (opp) => opp !== null
              );
              setFullOpportunities(validOpportunities);
            });
          } else {
            setFullOpportunities([]);
          }

          setContactEdit(formattedContact);

          // Carregar endereços do contato
          return contactService.getContactAddresses(contactId);
        })
        .then((addressResponse) => {
          const addresses = addressResponse?.data?.data || [];
          setContactAddresses(addresses);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Houve um erro ao buscar os dados do contato.', {
            autoClose: 3000,
            closeOnClick: true
          });
          setLoading(false);
        });
    }
  }, [contactId, recordTypeId, reset, customFields, refetchContactValue]);

  const onSubmit = async (data, tagsToUpdate) => {
    data.accountIds = accounts.map((account) => account.value);

    const dataDTO = formatCustomFieldsToSubmit(data, customFields);

    dataDTO.phone = normalizePhoneNumber(
      data?.__number__ || data?.phone?.number
    );
    dataDTO.ddi = normalizeDDI(
      data?.__ddi__ ||
        data?.phone?.ddi ||
        getDefaultCountry(dataDTO?.phone)?.dialCode
    );

    const tagsDTO = tagsToUpdate?.map((tag) => tag.value);
    dataDTO.tags = tagsDTO;

    contactService
      .updateContact(recordTypeId, contactId, dataDTO)
      .then(() => {
        toast.success('Contato atualizado com sucesso.', {
          autoClose: 3000,
          closeOnClick: true
        });
        history.push('/admin/crm/contact');
      })
      .catch((error) => {
        const msg =
          error?.response?.data?.message ??
          'Houve um erro ao atualizar o contato';
        toast.error(msg, {
          autoClose: 3000,
          closeOnClick: true
        });
      });
  };

  const handleUpdateComment = (dataComment) => {
    setOpenModalUpdateComment(true);
    setDataCommentUpdate(dataComment);
  };

  const handleCreateComment = () => {
    setOpenModalCreateComment(true);
  };

  const getCommnents = useCallback(() => {
    if (contactId) {
      ContactService.getContactsComments(contactId)
        .then((res) => {
          setListComments(res.data.data);
        })
        .catch((err) => {
          toast.error('Houve um erro ao buscar os comentários desse contato', {
            closeOnClick: true,
            autoClose: 3000
          });
          console.log(err);
        });
    }
  }, [contactId]);
  useEffect(getCommnents, [getCommnents]);

  const reloadComments = () => {
    ContactService.getContactsComments(contactId).then((res) => {
      setListComments(res.data.data);
    });
  };

  const errorFormMessage = (message) => (
    <p style={{ color: 'red' }}>{message}</p>
  );

  if (isLoadingCustomFields) {
    return (
      <Row className="justify-content-md-center">
        <Loader />
      </Row>
    );
  }

  const openGoogleMaps = () => {
    window.open(
      'https://maps.google.com?q=' +
        contactEdit.latitude +
        ',' +
        contactEdit.longitude
    );
  };

  return (
    <>
      <SimpleHeader
        name="Account edit"
        parentName="Account"
        returnPath="/admin/crm/contact"
        navigatorState={{ recordTypeId }}
      />
      <Container className="configuration-container mt--6" fluid>
        <Card>
          <CardBody>
            {contactEdit && (
              <Row className="mb-3">
                <Col sm={contactEdit.longitude ? '2' : '3'}>
                  <h3 className="font-weight-bold small mb-0">Criado por:</h3>
                  <span>{contactEdit?.createdByName}</span>
                </Col>
                <Col sm="3">
                  <h3 className="font-weight-bold small mb-0">Criado em:</h3>
                  <span>{toBrazilianFullDate(contactEdit?.createdAt)}</span>
                </Col>
                <Col sm="3">
                  <h3 className="font-weight-bold small mb-0">
                    Última modificação por:
                  </h3>
                  <span>{contactEdit?.lastUpdatedByName}</span>
                </Col>
                <Col sm="3">
                  <h3 className="font-weight-bold small mb-0">
                    Última modificação em:
                  </h3>
                  <span>{toBrazilianFullDate(contactEdit?.lastUpdatedAt)}</span>
                </Col>

                {contactEdit.longitude && contactEdit.latitude ? (
                  <Col
                    sm="1"
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center'
                    }}
                  >
                    <h3 className="font-weight-bold small mb-0">
                      Localização:
                    </h3>
                    <Button
                      color="primary"
                      outline
                      size="sm"
                      type="button"
                      title="Abrir endereço do cliente no Google Maps"
                      onClick={() => {
                        openGoogleMaps();
                      }}
                      style={{ maxWidth: '3rem' }}
                    >
                      <LocationOn />
                    </Button>
                  </Col>
                ) : null}
              </Row>
            )}
            <div className="mt-3" style={sectionStyle}>
              <h2>Dados do contato</h2>
              <Form
                className="needs-validation"
                onSubmit={handleSubmit((data) => onSubmit(data, tags))}
              >
                {loading ? (
                  <Loader />
                ) : (
                  <>
                    <Row>
                      <Col className="mb-3" sm="6">
                        <label className="form-control-label text-capitalize">
                          Nome <span style={{ color: 'red' }}>*</span>
                        </label>
                        <Controller
                          render={(props) => (
                            <Input
                              valueController={setValue}
                              value={props.value}
                              onChange={props.onChange}
                              type="text"
                              placeholder="Nome"
                            />
                          )}
                          control={control}
                          defaultValue=""
                          rules={{ required: 'Campo obrigatório' }}
                          name="name"
                        />
                        <ErrorMessage
                          errors={errors}
                          name="name"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                      <Col>
                        <FlexController
                          type="phone"
                          label="Telefone"
                          name="phone"
                          disabled={false}
                          showMessageButton={showMessageIconOnPhoneField}
                          showCallButton={showCallIconOnPhoneField}
                          handleSendTemplate={handleWhatsAppMessage}
                          watch={watch}
                          value={watch('phone')}
                          control={control}
                          errors={errors}
                          rules={{ required: 'Campo obrigatório' }}
                          valueController={(fieldName, value) => {
                            setValue(fieldName, value);
                          }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mb-3" sm="6">
                        <label className="form-control-label text-capitalize">
                          Email
                        </label>
                        <Controller
                          render={(props) => (
                            <Input
                              name="email"
                              valueController={setValue}
                              value={props.value}
                              onChange={props.onChange}
                              placeholder="seu-email@mail.com"
                            />
                          )}
                          control={control}
                          defaultValue=""
                          // O campo não é obrigatório mas é necessário validar o email com regex
                          rules={{
                            validate: (value) => {
                              if (!value) return true;

                              const emailRegex =
                                // eslint-disable-next-line no-useless-escape
                                /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;

                              return (
                                emailRegex.test(value) ||
                                'Email com formato incorreto'
                              );
                            }
                          }}
                          name="email"
                        />
                        <ErrorMessage
                          errors={errors}
                          name="email"
                          render={({ message }) => errorFormMessage(message)}
                        />
                      </Col>
                      <Col>
                        <label className="form-control-label text-capitalize">
                          Contas
                        </label>
                        <Select
                          styles={custom_select}
                          placeholder="Selecione contas..."
                          isMulti
                          isClearable={true}
                          name="accountIds"
                          isLoading={isSearching}
                          loadingMessage={() => 'Buscando...'}
                          noOptionsMessage={({ inputValue }) =>
                            !inputValue
                              ? 'Digite para pesquisar'
                              : 'Nenhum resultado encontrado'
                          }
                          loadOptions={async (inputValue) => {
                            const res = await filterAccounts(inputValue);
                            return (
                              res &&
                              res.map((account) => ({
                                label: account.name,
                                value: account.id
                              }))
                            );
                          }}
                          onChange={(selectedOptions) => {
                            setAccounts(selectedOptions || []);
                          }}
                          value={accounts}
                        />
                      </Col>
                      <Col>
                        <SearchTagClientInput
                          setValueSelected={setTags}
                          defaultValue={tags}
                          isMulti={true}
                          isDisabled={false}
                          refetchContact={refetchContact}
                        />
                      </Col>
                    </Row>

                    <Row>
                      <CustomFieldsInputsForm
                        fields={customFields}
                        control={control}
                        errors={errors}
                        watch={watch}
                        isOnEditPage={true}
                        setValue={setValue}
                        Controller={Controller}
                        options={{
                          showCallIconOnPhoneField: true,
                          showMessageIconOnPhoneField: true
                        }}
                        contactMessageClientName={contactEdit?.name}
                      />
                    </Row>
                  </>
                )}

                <ReactButton btnColor="confirmation" type="submit">
                  Salvar
                </ReactButton>
              </Form>
            </div>

            {listComments && (
              <ListComments
                listComments={listComments}
                reloadComments={reloadComments}
                handleUpdateComment={handleUpdateComment}
              />
            )}
            <Row style={{ paddingTop: '20px' }}>
              <Col className="text-right">
                <Button
                  title="Adicionar novo comentário"
                  color="success"
                  type="button"
                  onClick={() => handleCreateComment()}
                >
                  <FiPlus size={16} /> Adicionar Comentário
                </Button>
              </Col>
            </Row>

            <CommentModal
              render={getCommnents}
              contactId={contactId}
              isModalOpen={openModalCreateComment}
              onModalToggle={setOpenModalCreateComment}
              unmountOnClose={true}
            />

            <ModalComment
              render={getCommnents}
              dataComment={dataCommentUpdate}
              isModalOpen={openModalUpdateComment}
              onModalToggle={setOpenModalUpdateComment}
              unmountOnClose={true}
            />

            {/* Seção de Endereços */}
            <div className="mt-3" style={sectionStyle}>
              <Row className="align-items-center mb-2">
                <Col>
                  <h2>Endereços ({contactAddresses?.length || 0})</h2>
                </Col>
                <Col className="text-right">
                  <AddAddressModal
                    entityType="contact"
                    entityId={contactId}
                    entity={contactEdit}
                    onAddedAddress={reloadContact}
                    buttonOpenModal={({ onClick }) => (
                      <Button
                        title="Adicionar novo endereço"
                        color="success"
                        size="sm"
                        type="button"
                        onClick={onClick}
                      >
                        <FiPlus size={16} /> Adicionar Endereço
                      </Button>
                    )}
                  />
                </Col>
              </Row>

              <ContactAddress
                addresses={contactAddresses}
                contactId={contactId}
                reloadContact={reloadContact}
              />
            </div>

            {sections.map(({ title, name, data }) => (
              <div key={title} className="mt-3" style={sectionStyle}>
                <h2>{`${title} (${data?.length || 0})`}</h2>
                {name === 'opportunity' ? (
                  <AccountOpportunities
                    opportunities={data || []}
                    reloadAccount={refetchContact}
                  />
                ) : (
                  <ContactProtocolsAndOpportunities
                    {...{
                      [name]: data,
                      recordTypeContact: recordTypeId,
                      contactId
                    }}
                  />
                )}
              </div>
            ))}
          </CardBody>
        </Card>
      </Container>
      <TemplatesModal
        isModalOpen={isModalTemplateMessageContactOpen}
        onModalToggle={setIsModalTemplateMessageContactOpen}
        clientNumber={whatsAppMessageContactInfo.telefone}
        clientDDI={whatsAppMessageContactInfo.ddi}
        clientName={whatsAppMessageContactInfo.nome}
        clientId={whatsAppMessageContactInfo.clientId ?? ''}
        isIsolated={true}
      />
    </>
  );
};

export default ContactDetails;
